var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAddCardPartnersDetails(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0998 25.1996C22.0998 24.5369 22.6371 23.9996 23.2998 23.9996H28.0998C28.7625 23.9996 29.2998 24.5369 29.2998 25.1996C29.2998 25.8624 28.7625 26.3996 28.0998 26.3996H23.2998C22.6371 26.3996 22.0998 25.8624 22.0998 25.1996Z",
    fill: "#15D4B6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0998 29.9996C22.0998 29.3369 22.6371 28.7996 23.2998 28.7996H30.4998C31.1625 28.7996 31.6998 29.3369 31.6998 29.9996C31.6998 30.6624 31.1625 31.1996 30.4998 31.1996H23.2998C22.6371 31.1996 22.0998 30.6624 22.0998 29.9996Z",
    fill: "#15D4B6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.2998 15.5996C5.2998 12.2855 7.98778 9.59961 11.3011 9.59961H37.6985C41.0118 9.59961 43.6998 12.2855 43.6998 15.5996V17.3996C43.6998 18.7251 42.6253 19.7996 41.2998 19.7996H11.2998C10.6371 19.7996 10.0998 19.2624 10.0998 18.5996C10.0998 17.9369 10.6371 17.3996 11.2998 17.3996H41.2998V15.5996C41.2998 13.6118 39.6872 11.9996 37.6985 11.9996H11.3011C9.31244 11.9996 7.6998 13.6118 7.6998 15.5996V32.3996C7.6998 34.3878 9.31158 35.9996 11.2998 35.9996H37.6998C39.688 35.9996 41.2998 34.3878 41.2998 32.3996V23.3996C41.2998 22.7369 41.8371 22.1996 42.4998 22.1996C43.1625 22.1996 43.6998 22.7369 43.6998 23.3996V32.3996C43.6998 35.7133 41.0135 38.3996 37.6998 38.3996H11.2998C7.9861 38.3996 5.2998 35.7133 5.2998 32.3996V15.5996Z",
    fill: "#15D4B6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8998 26.9996C15.5625 26.9996 16.0998 26.4624 16.0998 25.7996C16.0998 25.1369 15.5625 24.5996 14.8998 24.5996C14.2371 24.5996 13.6998 25.1369 13.6998 25.7996C13.6998 26.4624 14.2371 26.9996 14.8998 26.9996ZM14.8998 29.3996C16.888 29.3996 18.4998 27.7878 18.4998 25.7996C18.4998 23.8114 16.888 22.1996 14.8998 22.1996C12.9116 22.1996 11.2998 23.8114 11.2998 25.7996C11.2998 27.7878 12.9116 29.3996 14.8998 29.3996Z",
    fill: "#15D4B6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8997 30.5996C16.0765 30.5996 17.0885 31.4556 17.3228 32.6336C17.452 33.2837 18.0838 33.7058 18.7338 33.5766C19.3838 33.4473 19.806 32.8156 19.6767 32.1656C19.2302 29.9202 17.2774 28.1996 14.8997 28.1996C12.5221 28.1996 10.5693 29.9202 10.1228 32.1656C9.99353 32.8156 10.4157 33.4473 11.0657 33.5766C11.7157 33.7058 12.3474 33.2837 12.4767 32.6336C12.7109 31.4556 13.723 30.5996 14.8997 30.5996Z",
    fill: "#15D4B6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAddCardPartnersDetails);
export default __webpack_public_path__ + "static/media/iconAddCardPartnersDetails.4f1acb642670f919729983e2c69f735d.svg";
export { ForwardRef as ReactComponent };